export default __webpack_public_path__ + "static/media/code-bn.fd1276b3.png";